import { render } from "./LayoutOverview.vue?vue&type=template&id=28be9e1b&scoped=true"
import script from "./LayoutOverview.vue?vue&type=script&lang=js"
export * from "./LayoutOverview.vue?vue&type=script&lang=js"

import "./LayoutOverview.vue?vue&type=style&index=0&id=28be9e1b&lang=scss&scoped=true"
import "./LayoutOverview.vue?vue&type=style&index=1&id=28be9e1b&lang=scss"

import exportComponent from "/Users/patriksvensson/Documents/Projects/KK/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28be9e1b"]])

export default __exports__